import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { TDynamicData } from '../../types/dynamic-data';

import { TripDetailButton } from './trip-detail-button';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const TripCard = ({
  trip,
  className,
}: {
  trip: TDynamicData;
  className?: { container?: string };
}) => {
  return (
    <div
      className={cn(
        'col-span-1 flex w-full flex-col items-start justify-start gap-6',
        className?.container,
      )}
    >
      <Image
        src={trip?.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(trip?.image, 'Placeholder')}
        height={0}
        width={0}
        quality={75}
        className="h-[200px] w-full object-cover object-center sm:h-[215px] lg:h-[265px]"
        sizes="450px"
      />
      <h3 className={cn('font-heading', 'line-clamp-2 h-[56px] text-lg text-black xl:text-xl')}>
        {trip?.name}
      </h3>
      <TripDetailButton trip={trip} />
    </div>
  );
};
